import { render, staticRenderFns } from "./message-prescription.vue?vue&type=template&id=252550c2"
import script from "./message-prescription.vue?vue&type=script&lang=js"
export * from "./message-prescription.vue?vue&type=script&lang=js"
import style0 from "./message-prescription.vue?vue&type=style&index=0&id=252550c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports